export default __webpack_public_path__ + "static/media/grandPlace2a.cdf45f17.jpg";